<template>
  <div>
    <PCNavbar selectIndex="1"/>
    <MobileNavBar :currentActive="0"/>
    <CarouselHome />
    <TodoShow />
    <MobileTodoShow />
    <div class="bottom_circle hidden-xs-only">
      <div class="brain_title">覆盖多行业、多场景的解决方案</div>
      <div class="brain_desc" style="padding-bottom: 20px;">重点行业深耕，适配多项业务场景 <span @click="$router.push('/Solutions').catch(() => {})">查看更多<i class="el-icon-arrow-right"></i></span></div>
      <Accordion />
    </div>
    <div class="bottom_circle hidden-sm-and-up">
      <div class="brain_title">覆盖多行业、多场景的解决方案</div>
      <div class="brain_desc"><span @click="$router.push('/Solutions').catch(() => {})">查看更多<i class="el-icon-arrow-right"></i></span></div>
      <div class="bottom_circle_inner">
        <img src="../assets/img/mobile/hone-solution1.png" @click="$router.push('/Solutions/erp').catch(() => {})"/>
        <img src="../assets/img/mobile/hone-solution2.png" @click="$router.push('/Solutions/plm').catch(() => {})"/>
        <img src="../assets/img/mobile/hone-solution3.png" @click="$router.push('/Solutions/mes').catch(() => {})"/>
        <img src="../assets/img/mobile/hone-solution4.png" @click="$router.push('/Solutions/scm').catch(() => {})"/>
        <img src="../assets/img/mobile/hone-solution5.png" @click="$router.push('/Solutions/wms').catch(() => {})"/>
      </div>
    </div>
    <CoreCompetence/>
    <Zixun />
    <CooperationCustomer/>
    <CallMe/>
    <MobileCallme/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome from '@/components/carousel_home/index'
import Zixun from '@/components/zixun/index'
import TodoShow from '@/components/todo_show/index'
import MobileTodoShow from '@/components/todo_show/MobileIndex.vue'
import CoreCompetence from '@/components/core_competence/index'
import CooperationCustomer from '@/components/cooperation_customer/index'
import CallMe from '@/components/callme/index'
import Accordion from '@/components/accordion/index.vue'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    TodoShow,
    CoreCompetence,
    CooperationCustomer,
    CallMe,
    MobileCallme,
    MobileTodoShow,
    Zixun,
    Accordion
  }
}
</script>

<style lang="scss" scoped>

.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 20px;
  height: 750px;
  //background-image: url(../assets/img/smalldot.png),url(../assets/img/smalldot1.png);
  background: url('../assets/img/home/jjfa_bj.jpg') 0 0 no-repeat;
  background-size: 100% 100%;
  color: #fff;
  @media screen and (max-width: 768px) {
    height: auto;
    background:none;
    background-color: #F5F7FA;
    padding-top: 0;
  }
  .bottom_circle_inner{
    width: 95%;
    margin: auto;
    img{
      width: 100%;
      margin-top: 8PX;
    }
  }
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  .circle_img {
    width: 100%;
    img {
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }
  //background: #F5F7FA;
  .brain_title {
    color: #203040;
    font-size: 33px;
    font-weight: bold;
    padding: 40px 0 10px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 14px;
    letter-spacing: 1px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 30PX;
    }
    span{
      margin-left: 10px;color:#0052D9; letter-spacing: 0px;cursor: pointer;
    }
  }
}
.zixun{
  width: 100%;height:300px;background-color: #05102F;
  .zixun-img{
    height: 300px;width:55%;position: relative;float: right
  }
  .zixun-content{
    width: 70%;position: absolute;color:#fff;margin-left: 15%;padding: 70px 0 0 0;
    img{
      width: 40px;float: left;
    }
    .title{
      line-height: 40px;padding-top: -20px;float: left;margin-left: 10px;font-size: 28px
    }
    .desc{
      width: 100%;margin-top: 50px;font-size: 14px;line-height: 30px;letter-spacing: 1px;
      div{
        margin-top: 30px;
        a{
          color: #fff;
        }
        .zixun-btn{
          background-color: #0052D9;width: 170px;padding: 12px;border: 0;
        }
      }
    }
  }
}
.zixun-bg{
  height: 300px;float: right;margin-top: -350px;position: relative;text-align: right;
  .zixun-bg-img{
    width: 300px;
  margin-right: 200px;
  }
}
</style>